import { Sparkles, Zap, Tag, FileText, Coins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const features = [
  {
    icon: Zap,
    title: "AI Extraction",
    description: "Pulls names, companies, titles, and phone numbers instantly from any email.",
  },
  {
    icon: Tag,
    title: "Smart Categories",
    description: "AI assigns custom color tags to your contacts automatically.",
  },
  {
    icon: FileText,
    title: "Smart Notes",
    description: "Creates company and person summaries from web + LinkedIn context.",
  },
  {
    icon: Coins,
    title: "Credit-based System",
    description: "Pay only for what you use. No subscriptions. No bloat.",
  },
];

export const Solution = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary">You don't need a CRM. You need clarity.</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Get CRM intelligence — without the CRM.
            </h2>
            
            <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Our AI plugin gives you the smart parts of a CRM right inside Outlook: automatic contact extraction, intelligent tagging, and instant research.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-card rounded-xl p-6 shadow-card border border-border hover:shadow-elevated transition-smooth"
              >
                <div className="mb-4 inline-flex p-3 rounded-lg bg-primary/10">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-bold mb-2 text-foreground">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <Button variant="hero" size="lg" asChild>
              <Link to="/auth">Try with 20 free credits</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
